import './style.css';

function Header(){    
    return (
        <>
            <h1>Herbert Roberti Júnior</h1>
            <h2>FullStack Development</h2>
            <div className="social-media">
            <a href="https://www.linkedin.com/in/herbert-roberti" target="_blank" rel='noreferrer'>Linkedin</a>            
            <a href="https://github.com/Herbert-Junior" target="_blank" rel='noreferrer'>Github</a>
            </div>        
        </>
    )
}

export default Header;